export const Options = {
    body: {
        key: [],
        name: [],
        type: [],
        color: [],
        enable: [],
        canAnalysis: []
    },
    refs: {
        props: '[prop]'
    },
    list: {
        key: self => self.key
    }
};
